import classNames from 'classnames';
import type { JSX } from 'react';
import React from 'react';

import { CreativePreviewImage, Tooltip } from '@feathr/components';

import type { IThumbnailCarouselItem } from './ThumbnailCarousel.types';

import * as styles from './ThumbnailCarousel.css';

interface IThumbnailItemProps {
  creative: IThumbnailCarouselItem;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

function ThumbnailItem({
  creative,
  isSelected,
  onSelect,
}: Readonly<IThumbnailItemProps>): JSX.Element {
  return (
    <Tooltip className={styles.tooltipTrigger} title={creative.filename}>
      <button
        className={classNames(styles.thumbnailButton, {
          [styles.selected]: isSelected,
        })}
        data-name={`thumbnail-${creative.id}`}
        onClick={(): void => onSelect(creative.id)}
        type={'button'}
      >
        <CreativePreviewImage
          alt={creative.filename}
          className={styles.thumbnailImage}
          isVideo={creative.isVideo ?? false}
          placeholderClassName={styles.thumbnailPlaceholder}
          skeletonClassName={styles.thumbnailSkeleton}
          src={creative.thumbnailUrl}
        />
      </button>
    </Tooltip>
  );
}

export default ThumbnailItem;
